import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { load } from "@cashfreepayments/cashfree-js";
import { Box, Button, Grid2, Paper, Typography } from "@mui/material";
import Swal from "sweetalert2";
import successImg from "../Assets/TransactionSuccessandFailed/SuccessGif.gif";
import failedImg from "../Assets/TransactionSuccessandFailed/TransactionFailed.png";
import { Timeline } from "@mui/icons-material";
import { TimeIcon } from "@mui/x-date-pickers-pro";

const NewWindowPG = () => {
  const [searchParams] = useSearchParams();
  const pg = searchParams.get("pg");
  const orderid = searchParams.get("orderid");
  const txnId = searchParams.get("txnId");
  const orderdata = searchParams.get("orderdata")
    ? JSON.parse(decodeURIComponent(searchParams.get("orderdata")))
    : null;
  const [pgClosed, setPGClosed] = useState(false);
  const [txnDetails, setTXNDetails] = useState({
    txnid: null,
    amount: null,
    status: null,
    timestamp: null,
    utr: null,
    message: null,
    type: null,
  });
  const [timeLeft, setTimeLeft] = useState(10); // 10 secs countdown

  const handlePaymentStatus = async () => {
    if (!txnId) {
      return null;
    }
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/auth/transaction-api-v2",
        { txnid: txnId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTXNDetails(response.data); // Update state with response data
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  };

  const txnStatusCheck = async (orderNo) => {
    const url =
      "https://api.ipaisa.co.in/myapp/auth/get-pg-transaction-status";
    const headers = {
      id: orderNo,
      service: pg,
    };

    try {
      const response = await axios.get(url, { headers });
      setTXNDetails(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  const InitiatingEaseBuzz = () => {
    // Load the Easebuzz script
    const script = document.createElement("script");
    script.src =
      "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.EasebuzzCheckout) {
        const easebuzzCheckout = new window.EasebuzzCheckout(orderid, "prod");

        const options = {
          access_key: orderid,
          onResponse: (response) => {
            console.log(response);
          },
          theme: "#123456",
        };
        easebuzzCheckout.initiatePayment(options);
      }
    };

    // Check transaction status every 3 seconds
    const checkTXNStatus = setInterval(async () => {
      const txnStatusResp = await handlePaymentStatus(txnId);

      if (
        txnStatusResp?.status !== "preInitiated" &&
        txnStatusResp?.status !== "initiated" &&
        txnStatusResp?.status !== "pending"
      ) {
        clearInterval(checkTXNStatus);

        setPGClosed(true);
        if (document.body.contains(script)) {
          console.log("in if (document.body.contains(script))");
          document.body.removeChild(script); // Only remove if present
          startCountDown();
        }
      }
    }, 3000);
  };

  const cashFreePayment = async (data) => {
    const { orderId, paymentSessionId } = data;
    let cashfree;
    const initialCashFree = async function () {
      cashfree = await load({
        mode: "production",
      });
    };

    // Wait for initialization
    await initialCashFree();

    // Proceed only after cashfree is initialized
    if (cashfree) {
      const checkoutOptions = {
        paymentSessionId:
          // "session_6cA3p9vbcanFF8acgNprGGSUAGxdPbJpTe9UmhU-TQxIP-5ka1AnhXgN9tWJPn4HvNOHpksbhD0J3_DIWT4WIka-nPWXI3Pl9S8cmBvpNuMTNpGZiMQ1Xg4payment",
          paymentSessionId, // Use the dynamic paymentSessionId
        redirectTarget: "_modal",
      };

      // Call the checkout method
      cashfree.checkout(checkoutOptions).then((result) => {
        console.log(result);
        if (result.error) {
          // This will be true whenever user clicks on close icon inside the modal or any error happenhjs during the payment
          console.log(
            "User has closed the popup or there is some payment error, Check for Payment Status"
          );
          console.log(result.error);
          txnStatusCheck(orderId);
          // setPGClosed(true);
          startCountDown();
          // Check transaction status every 3 seconds
        }
        if (result.redirect) {
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          txnStatusCheck(orderId);
          console.log("Payment will be redirected");
          setPGClosed(true);
          startCountDown();
        }
        if (result.paymentDetails) {
          txnStatusCheck(orderId);
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
          setPGClosed(true);
          startCountDown();
        }
      });
    } else {
      console.error("Failed to initialize Cashfree.");
    }
  };

  const initiateRazorPayment = () => {
    if (!orderdata) {
      Swal.fire({
        title: "Payment Failed",
        text: "We cant process your request, Please try again later sometime..!!",
        icon: "error",
      });
      return null;
    }
    try {
      console.log(orderdata.id);
      const { id, amount, currency, key } = orderdata;
      const options = {
        key: "rzp_live_9lZyU2RZhKmttY",
        amount: amount,
        currency: currency,
        name: "ipaisa",
        description: "Transaction",
        order_id: id,
        image:
          "https://test.ipaisa.co.in/static/media/iPaisaLogo.3682d2408e2c0eb923ed.jpg",
        handler: async function (response) {
          const paymentData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };
          try {
            const verifyResponse = await axios.post(
              "https://api.ipaisa.co.in/myapp/auth/verify_razorpay_payment",
              paymentData
            );
            if (verifyResponse.status === 200) {
              console.log(verifyResponse);
              console.log("Payment successful and verified!");
              startCountDown();
            } else {
              console.log(verifyResponse);
              console.log("Payment verification failed");
              //   startCountDown();
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            // startCountDown();
          }
        },
        prefill: {
          name: sessionStorage.getItem("username"),
          // email: sessionStorage.getItem(''),
          // contact: "8421570262",
        },
        notes: {
          address: "Corporate Office",
        },
        theme: {
          color: "#03DBFC",
        },
      };

      // Open Razorpay checkout window
      const rzp1 = new window.Razorpay(options);
      rzp1.open();

      const checkTXNStatus = setInterval(async () => {
        const txnStatusResp = await txnStatusCheck(id);

        if (
          txnStatusResp?.status === "captured" ||
          txnStatusResp?.status === "failed"
        ) {
          setPGClosed(true);
          clearInterval(checkTXNStatus);
        }
      }, 3000);
      // Payment failure handler
      rzp1.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        // startCountDown();
      });
      rzp1.on("payment.captured", function (response) {
        console.log("Payment captured:", response);
        // startCountDown();
      });
    } catch (error) {
      console.error("Error in payment handler:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const startCountDown = () => {
    if (timeLeft > 0 && !pgClosed) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer); // Stop the timer when time reaches 0
            window.close(); // Close the window
            return 0; // Ensure timeLeft doesn't go negative
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer); // Cleanup when component unmounts
    }
  };

  useEffect(() => {
    if (pg === "EASEBUZZ") {
      InitiatingEaseBuzz();
    } else if (pg === "UCASHFREE" || pg === "TCASHFREE") {
      console.log(orderdata);
      cashFreePayment(orderdata);
    } else if (pg === "RAZORPAY") {
      console.log(orderdata);
      initiateRazorPayment();
    } else {
      Swal.fire({
        title: "Payment Failed",
        text: "We cant process your request, Please try again later sometime..!!",
        icon: "error",
      });
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh", // Full screen height
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {pgClosed ? (
        <Paper sx={{ padding: 4 }} elevation={4}>
          <Grid2 container direction="column" alignItems="center" spacing={2}>
            <Grid2>
              {(txnDetails?.status?.toLowerCase() === "success" ||
                txnDetails?.status === "captured") && (
                <img src={successImg} alt="Success" width="100" />
              )}

              {(txnDetails?.status?.toLowerCase() === "failed" ||
                txnDetails.status === "USER_DROPPED" ||
                txnDetails.status === "userCancelled") && (
                <img src={failedImg} alt="Failed" width="100" />
              )}
              {txnDetails?.status?.toLowerCase() !== "success" &&
                txnDetails?.status?.toLowerCase() !== "failed" &&
                txnDetails.status !== "USER_DROPPED" &&
                txnDetails.status !== "userCancelled" && (
                  <TimeIcon sx={{ color: "gold", fontSize: 80 }} />
                )}
            </Grid2>

            <Grid2>
              <Typography variant="h4">Your Transaction Details</Typography>
            </Grid2>
            <Grid2>
              <Typography variant="body1">
                <strong>Transaction ID:</strong> {txnDetails.txnid || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Amount:</strong>{" "}
                {txnDetails.amount ? `₹${txnDetails.amount}` : "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Timestamp:</strong>{" "}
                {txnDetails.timestamp
                  ? new Date(txnDetails.timestamp).toLocaleString()
                  : "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Status:</strong> {txnDetails.status || "N/A"}
              </Typography>
            </Grid2>

            {/* Spacer to push button to bottom */}
            <Grid2>
              <Typography variant="body1">
                <strong>Keep it for Future Purpose</strong>
              </Typography>
            </Grid2>

            <Grid2>
              <Button
                variant="outlined"
                onClick={() => window.close()}
                sx={{ width: "200px", marginBottom: "20px" }} // Ensures spacing at the bottom
              >
                Close This Window
              </Button>
              <Typography variant="h6">
                Closing this window in: {Math.floor(timeLeft / 60)}:
                {("0" + (timeLeft % 60)).slice(-2)}
              </Typography>
            </Grid2>
          </Grid2>
        </Paper>
      ) : (
        <Button
          variant="outlined"
          onClick={() => window.close()}
          sx={{ width: "200px", marginBottom: "20px" }} // Ensures spacing at the bottom
        >
          Close This Window
        </Button>
      )}
    </Box>
  );
};

export default NewWindowPG;
